// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';
import { type CardBrand } from '@tectonics/prs/card-brand';

export function validateCardSecurityCode(cardSecurityCode: string, cardBrand: ?CardBrand): ?UserInputValidationError {
  if(!cardSecurityCode) {
    return { id: 'empty' };
  } else if (!getCardSecurityPatternFromBrand(cardBrand).test(cardSecurityCode)) {
    return { id: 'invalid-pattern' };
  }
}

function getCardSecurityPatternFromBrand(cardBrand: ?CardBrand): RegExp {
  if (cardBrand === 'amex') {
    return /^(?!0000)\d{4}$/;
  }
  return /^\d{3}$/;
}
